// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/iconfont/iconfont.css
// module id = 61
// module chunks = 0